import { render, staticRenderFns } from "./ProcessDesigner.vue?vue&type=template&id=b3acebe4&scoped=true"
import script from "./ProcessDesigner.vue?vue&type=script&lang=js"
export * from "./ProcessDesigner.vue?vue&type=script&lang=js"
import style0 from "./ProcessDesigner.vue?vue&type=style&index=0&id=b3acebe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3acebe4",
  null
  
)

export default component.exports